<template>
  <SpectreText
    size="sm"
    color="secondary"
  >
    By signing into spectre.uk.com, I agree to the <a
      class="font-bold hover:underline"
      href="https://spectre.uk.com/privacy"
    >Privacy Policy</a> and
    <a
      class="font-bold hover:underline"
      href="https://spectre.uk.com/terms"
    >Terms of service</a>.
  </SpectreText>
</template>

<script setup lang="ts">
import { SpectreText } from '@agentsoftware/spectre-ui';
</script>
